import { CharacterAttack } from './CharacterAttack';

export class CharacterAttackCharge extends CharacterAttack {
  trigger() {
    super.trigger();
    this._direction = this._character.faceDirection;
    this._updatePosition = this.character.x;
    this._positionTracking = [];
    this.character.velocity.x = this.character.movementSpeed * 2.5 * this.character.faceDirection;

    const viewport = this.scene.viewport;
  }

  _triggerAttackAnimation() {
    this.character.playAnimation('charge', true);
  }

  updateActive(delta) {
    super.updateActive(delta);

    this.character.velocity.x = this.character.movementSpeed * 2.5 * this.character.faceDirection;
    const dx = Math.abs(this.character.x - this._updatePosition);
    this._positionTracking.push(dx);
    if (this._positionTracking.length > 5) {
      this._positionTracking.shift();
      let dist = 0;
      for (let i = 0; i < this._positionTracking.length - 1; i++) {
        dist += this._positionTracking[i];
      }
      if (dist < 1) return this.completeAttack();
      this._updatePosition = this.character.x;

      const viewport = this.scene.viewport;
      if (
        this.attackCollider.x < viewport.x ||
        this.attackCollider.x + this.attackCollider.width > viewport.x + viewport.width
      ) {
        return this.completeAttack();
      }
    }
  }
}
